export const playersState =  {
    state:() => ({
      players: [],
      teams: []
    }),
    getters: {
      players: state => {
        return state.players;
      },
      teams: state => {
        return state.teams;
      }
    },
    mutations: {
    },
    actions: {
  
    }
};